import React, { Component } from "react";
import { connect } from "react-redux";
import { getStatusViewData } from "../../actions/statusView_action";
import DropDown from 'shared/components/DropDown/index';
import ActionButton from 'shared/components/ActionButton/index';
import simpleReactValidatorMin from "simple-react-validator";
import { fetchFacilityList, fetchGroupList } from "../../actions/actions";
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import * as FontAwesome from 'react-icons/lib/fa'
import moment from "moment";
var dateFormat = require("dateformat");

class StatusView extends Component {
    constructor(props) {
        super(props);
        this.dispatch = this.props.dispatch;
        this.validator = new simpleReactValidatorMin();
        this.state = {
            loading: false,
            year: moment().get("year"),
            facilityId: [],
            statusViewData: [],
            organizationList: [],
            facilityListByOrganization: [],
            groupId: ''
        };

        this.handleGroupChange = this.handleGroupChange.bind(this);
        this.handleFacilityChange = this.handleFacilityChange.bind(this);
        this.handleChangeYear = this.handleChangeYear.bind(this);
        this.searchData = this.searchData.bind(this);
        this.validateFormFields = this.validateFormFields.bind(this);
    }

    componentDidMount() {
        this.setState((prevState) => {
            return {
                ...prevState,
                loading: true,
            };
        });
        this.dispatch(fetchGroupList());
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.status_view_data !== this.props.status_view_data) {
            let completed = [];
            let upComing = [];
            let due = [];

            let viewData = this.props.status_view_data;

            for (let i = 0; i < viewData.length; i++) {
                let month = viewData[i].data;
                for (let j = 0; j < month.length; j++) {
                    let record = month[j];

                    if (record.status === 5) {
                        completed = [...completed, record];
                    }
                    if (moment(record.planned_start_date_time).isAfter(moment()) && record.status !== 5) {
                        upComing = [...upComing, record];
                    }
                    // if (record.status === 1 || record.status === 2) {
                    //     upComing = [...upComing, record];
                    // }
                    if (moment(record.planned_start_date_time).isBefore(moment()) && record.status !== 5) {
                        due = [...due, record];
                    }
                    // if (record.status === 3) {
                    //     due = [...due, record];
                    // }
                }
            }

            this.setState(() => {
                return {
                    ...prevState,
                    statusViewData: { completed, due, upComing },
                    loading: false,
                };
            });
        }

        if (this.props.group_items !== prevProps.group_items) {
            this.setState(() => {
                return {
                    ...prevState,
                    organizationList: this.props.group_items,
                    loading: false,
                };
            });
        }

        if (this.props.facility_data !== prevProps.facility_data) {
            this.setState(() => {
                return {
                    ...prevState,
                    facilityListByOrganization: this.props.facility_data,
                    loading: false,
                };
            });
        }

        if (prevState.year !== this.state.year) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    loading: true,
                };
            });
            this.dispatch(
                getStatusViewData({
                    year: this.state.year,
                    fId: this.state.facilityId.map(({ value }) => value),
                })
            );
        }
    }

    validateFormFields(fields = []) {
        var that = this;
        let isValid = true;

        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            if (!that.validator.fieldValid(field)) {
                isValid = false;
                break;
            }
        }

        if (!isValid) {
            that.validator.showMessages();
            that.forceUpdate();
        }

        return isValid;
    }

    handleGroupChange(event) {
        let groupId = event.target.value;
        this.setState((prevState) => {
            return {
                ...prevState,
                statusViewData: [],
                facilityId: [],
                loading: true,
                groupId
            };
        });
        this.dispatch(fetchFacilityList(groupId));
    }

    handleFacilityChange(event) {
        this.setState((prevState) => {
            return {
                ...prevState,
                facilityId: event,
            };
        });
    }

    searchData() {
        if (this.validateFormFields(['selected_group', 'selected_facility'])) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    loading: true,
                };
            });
            this.dispatch(
                getStatusViewData({
                    year: this.state.year,
                    fId: this.state.facilityId.map(({ value }) => value),
                })
            );
        }
    }

    handleChangeYear(type) {
        if (this.validateFormFields(['selected_group', 'selected_facility'])) {
            let updatedYear = "";
            if (type === "prev") {
                updatedYear = moment(this.state.year, "YYYY")
                    .subtract(1, "Y")
                    .format("YYYY");
            }
    
            if (type === "next") {
                updatedYear = moment(this.state.year, "YYYY")
                    .add(1, "Y")
                    .format("YYYY");
            }
            this.setState((prevState) => {
                return {
                    ...prevState,
                    year: updatedYear,
                };
            });
        }
    }

    render() {
        return (
            <div className="sv-page-bg">
                <BlockUi tag="div" blocking={this.state.loading}>

                    <div className="sv-page-card">

                        {/* Filter row */}
                        <div className="sv-filter-row">

                            {/* Group select */}
                            <div className="sv-filter-field sv-filter-field--group">
                                <div className="sv-select-wrap">
                                    <DropDown
                                        name={"selected_group"}
                                        data={this.state.organizationList}
                                        first_element={"--Select Group--"}
                                        onChange={this.handleGroupChange}
                                        className="sv-native-select"
                                    />
                                </div>
                                <span className="error-text">
                                    {this.validator.message(
                                        "selected_group",
                                        this.state.groupId,
                                        "required|gt:0",
                                        false,
                                        { default: "This field is required." }
                                    )}
                                </span>
                            </div>

                            {/* Facility multi-select */}
                            <div className="sv-filter-field sv-filter-field--facility">
                                <Select
                                    name={"selected_facility"}
                                    options={this.state.facilityListByOrganization.map(
                                        ({ name, id }) => ({ label: name, value: id })
                                    )}
                                    multi
                                    value={this.state.facilityId}
                                    onChange={this.handleFacilityChange}
                                />
                                <span className="error-text">
                                    {this.validator.message(
                                        "selected_facility",
                                        this.state.facilityId,
                                        "required",
                                        false,
                                        { default: "This field is required." }
                                    )}
                                </span>
                            </div>

                            {/* Year navigator — inline in filter row */}
                            <div className="sv-year-nav">
                                <span
                                    className="sv-year-nav__btn"
                                    onClick={() => this.handleChangeYear("prev")}
                                >
                                    <FontAwesome.FaChevronCircleLeft />
                                </span>
                                <span className="sv-year-nav__label">
                                    {this.state.year}
                                </span>
                                <span
                                    className="sv-year-nav__btn"
                                    onClick={() => this.handleChangeYear("next")}
                                >
                                    <FontAwesome.FaChevronCircleRight />
                                </span>
                            </div>

                            {/* Filter button */}
                            <div className="sv-filter-action">
                                <ActionButton
                                    color={"primary"}
                                    size={"md"}
                                    button_name={"Filter"}
                                    button_click={this.searchData}
                                    className="sv-filter-btn"
                                />
                            </div>

                        </div>

                        {/* Kanban board */}
                        <div className="sv-board">
                            {Object.entries(this.state.statusViewData).map(([key, value]) => {
                                const colLabel =
                                    key === "completed" ? "Completed"
                                    : key === "upComing" ? "Upcoming"
                                    : key === "due"      ? "Due"
                                    : key;

                                return (
                                    <div key={key} className="sv-col">
                                        <div className="sv-col__header">
                                            <span className="sv-col__title">{colLabel}</span>
                                            <div className="sv-col__divider" />
                                        </div>
                                        <div className="sv-col__body">
                                            {value.length > 0
                                                ? value.map((task) => {
                                                    const {
                                                        status,
                                                        periodical_name,
                                                        planned_start_date_time,
                                                        user_list,
                                                        id,
                                                        contract_facility_name,
                                                    } = task;

                                                    const statusClass =
                                                        status === 1 ? "sv-card--unassigned"
                                                        : status === 2 ? "sv-card--assigned"
                                                        : status === 3 ? "sv-card--inprogress"
                                                        : status === 4 ? "sv-card--abandoned"
                                                        : status === 5 ? "sv-card--completed"
                                                        : "";

                                                    return (
                                                        <div
                                                            key={id}
                                                            className={`sv-card ${statusClass}`}
                                                            id={id}
                                                        >
                                                            <p className="sv-card__title">
                                                                {periodical_name}
                                                            </p>
                                                            <p className="sv-card__meta">
                                                                {dateFormat(planned_start_date_time, "dd mmm")}
                                                                {contract_facility_name ? ` \u2022 ${contract_facility_name}` : ""}
                                                            </p>
                                                            {user_list && user_list.length > 0 && (
                                                                <div className="sv-card__avatars">
                                                                    {user_list.map((x) => (
                                                                        <div className="sv-avatar" key={x.id}>
                                                                            {x.user_name.slice(0, 1)}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                                : <p className="sv-col__empty">No Data Available</p>
                                            }
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                </BlockUi>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {
        postsBySubreddit: { status_view_data, group_items, facility_data },
    } = state;

    return { status_view_data, group_items, facility_data };
}

const StatusViewContainer = connect(mapStateToProps)(StatusView);

export default StatusViewContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/statusView/index.js